import RecurringTasksModal from './RecurringTasksForm';

export default RecurringTasksModal;
